import request from '../../../request';

export default {
  actions: {
    getCompanies(_, page) {
      return request.get('companies', {
        params: {
          page: page
        }
      });
    },

    changeCompanyExpiration(_, payload) {
      return request.put('companies/change-expiration/' + payload.id, payload);
    },

    getCompany(_, id) {
      return request.get('companies/' + id);
    },

    createCompany(_, payload) {
      return request.post('companies', payload);
    },

    updateCompany(_, payload) {
      return request.put('companies/' + payload.id, payload);
    },

    deleteCompany(_, id) {
      return request.delete('companies/' + id);
    },
  }
}
